import { createFileRoute } from "@tanstack/react-router";
import { TaxPenalties } from "@/components/TaxPenalties";

function RouteComponent() {
  return <TaxPenalties />;
}

export const Route = createFileRoute("/_authenticated/tax-penalties/")({
  component: RouteComponent,
  staticData: { page: "tax" },
});
